import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, DeliveryMethod, Divider, Text } from '@reveni-io/reveni-ui'

const ReturnInstructionUses = ({ deliveryMethods, regions, onSelectDeliveryMethod }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      <Divider />
      <Text type="titleM">{t('Instrucciones usadas en')}:</Text>
      {deliveryMethods?.length > 0 ? (
        deliveryMethods.map((method, index) => (
          <DeliveryMethod
            key={method.id}
            data={method}
            regions={regions}
            index={index}
            onEdit={onSelectDeliveryMethod}
            isEditable={false}
            showSwitch={false}
            showRanges={false}
            customBackgroundColor={theme.colors.background.secondary}
            containerPadding={`${theme.spacing.sp8} ${theme.spacing.sp16}`}
          />
        ))
      ) : (
        <Alert type="info">
          {t('Estas instrucciones de devolución aún no están asociadas a ningún método de devolución.')}
        </Alert>
      )}
    </>
  )
}

export default ReturnInstructionUses
